import React from "react";
import { useParams } from "react-router-dom";
import {
  keynoteSpeakers,
  invitedSpeakers,
  sessionChairs,
} from "../data/mockData";

const Speakers = () => {
  const { type } = useParams();

  const speakerData = {
    keynote: { title: "Keynote Speakers", speakers: keynoteSpeakers },
    invited: { title: "Invited Speakers", speakers: invitedSpeakers },
    chairs: { title: "Session Chairs", speakers: sessionChairs },
  };

  const currentData = speakerData[type] || speakerData.keynote;

  return (
    <div className="bg-white min-h-screen">
      {/* Page Header */}
      <div className="bg-blue-950 py-16 text-center overflow-hidden">
        <h1 className="relative text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 tracking-wider px-4">
          {currentData.title.toUpperCase()}
        </h1>
        <div className="relative w-32 sm:w-48 h-1 bg-primary-600 mx-auto"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="text-center mb-12">
          <p className="text-xl text-gray-700">
            Distinguished speakers and experts sharing their insights at
            TG-SMART 2026
          </p>
        </div>

        {/* Speaker Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {currentData.speakers.map((speaker) => (
            <div
              key={speaker.id}
              className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-primary-600"
            >
              <div className="h-72 overflow-hidden">
                <a
                  href={speaker.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={speaker.image}
                    alt={speaker.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300 cursor-pointer"
                  />
                </a>
              </div>

              <div className="p-4 text-center bg-gradient-to-r from-blue-50 to-blue-100">
                <h3 className="text-lg font-bold text-gray-800 mb-1">
                  <a
                    href={speaker.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline hover:text-blue-600 transition-colors duration-200"
                  >
                    {speaker.name}
                  </a>
                </h3>

                <p className="text-sm text-primary-700 font-semibold">
                  {speaker.designation}
                </p>

                <p className="text-xs text-gray-600 mt-1 leading-tight">
                  {speaker.organization}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Speakers;
